import { ApiGenericResponse } from "../ApiGenericResponse";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";

const ENDPOINT = "/dataflow/message/failed/skip";

export class PostDataFlowSkipFailedMessageCommad extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    params: PostDataFlowSkipFailedMessageReqData;

    constructor(rayId: string, message: string) {
        super();
        this.params = new PostDataFlowSkipFailedMessageReqData(rayId, message);
    }

    public async execute(): Promise<ApiGenericResponse> {
        let res = await this.executeCommand(null, null, this.params);
        return new ApiGenericResponse(res);
    }
}

export class PostDataFlowSkipFailedMessageReqData {
    installationName: string;
    converterType: string;

    constructor(installationName: string, converterType: string) {
        this.installationName = installationName;
        this.converterType = converterType;
    }
}
